/** @file cubeFaceView: the camera change a click on an orientation cube face makes. */
import type { CameraState } from '../../state/editorTypes';
import { shortestYawDelta } from './shortestYawDelta';
import type { CubeFace, CubeFaceKind } from './cubeFaces';

/** One rule per face kind; a new kind is a type error until it has one. */
const BY_KIND: { [K in CubeFaceKind['kind']]: (face: Extract<CubeFaceKind, { kind: K }>, range: [number, number]) => Partial<CameraState> } = {
  // Camera yaw 0 stands south looking north and yaw 90 stands east: standing at bearing b is yaw 180 - b.
  side: (face) => ({ yawDeg: shortestYawDelta(0, 180 - face.bearingDeg) }),
  up: (_face, range) => ({ pitchDeg: range[1] }),
  down: (_face, range) => ({ pitchDeg: range[0] }),
};

/**
 * A side face turns the camera to stand on that side (the face comes to the front), keeping the pitch; up and down
 * set the pitch to the high / low end of the profile camera's `pitchRange`, keeping the yaw.
 */
export function cubeFaceView(face: CubeFace, pitchRange: [number, number]): Partial<CameraState> {
  return (BY_KIND[face.kind] as (f: CubeFace, r: [number, number]) => Partial<CameraState>)(face, pitchRange);
}
